import { FlightsStatus } from '../models/flights';


export const defaultFlightPackage = {
    flightsPackageId: -1,
    surchargeAmount: 0,
    surchargeCurrencyId: 5,
    surchargeOriginAmount: 0,
    surchargeOriginCurrencyId: 5,
    isChecked: true,
    status: FlightsStatus.NotConcrete,
    from: [],
    to: []
};
